export const trimString = (
  str: string,
  maxLength: number,
  suffix = '...',
): string => {
  if (!str) {
    return ''
  }

  if (str.length <= maxLength) {
    return str
  }
  return str.slice(0, maxLength) + suffix
}

export const createDynamicEndpointRegex = (template: string): RegExp => {
  const pattern = template
    .replace(/\{[^}]+\}/g, '[^/]+')
    .replace(/\//g, '\\/')
    .replace(/\./g, '\\.')
    .replace(/\*/g, '.*')

  return new RegExp(`^${pattern}$`)
}
